export * from '@cipafacil/services/confirmation/confirmation.module';
export * from '@cipafacil/services/confirmation/confirmation.service';
export * from '@cipafacil/services/confirmation/confirmation.types';
